import { FC, useEffect } from 'react';
import { useTheme } from 'styled-components';
import { SecondaryButton } from '@stax-core/truffle-components';
import {
  usePlaidLink,
  PlaidLinkOptions,
  PlaidLinkOnSuccess,
  PlaidLinkOnExit,
  PlaidLinkOnEvent,
} from 'react-plaid-link';
import { Button } from '../Button';

export const PlaidLink: FC<{
  linkToken: string;
  onSuccess: PlaidLinkOnSuccess;
  onExit: PlaidLinkOnExit;
  text: string;
}> = ({ linkToken, onSuccess, onExit, text }) => {
  const theme = useTheme();
  const config: PlaidLinkOptions = {
    onSuccess,
    onExit,
    onEvent: onExit as unknown as PlaidLinkOnEvent,
    token: linkToken,
  };
  // When Plaid authenticates to an institution with OAuth on mobile, the page redirects to the
  // oauth domain and back to the current URL with an added 'oauth_state_id' parameter
  const isOAuthRedirect = window.location.href.includes('?oauth_state_id');
  if (isOAuthRedirect) {
    config.receivedRedirectUri = window.location.href;
  }

  // on unmount the Link instance is automatically destroyed
  const { open, ready } = usePlaidLink(config);

  // open Link immediately when ready when returning from OAuth redirect
  useEffect(() => {
    if (isOAuthRedirect && ready) {
      open();
    }
  }, [ready, open, isOAuthRedirect]);

  const id = 'account-link-button';

  return theme.name === 'gogurt' ? (
    <SecondaryButton
      id={id}
      data-testid={id}
      trackingId={id}
      onClick={event => {
        event.preventDefault();
        linkToken && open();
      }}
      disabled={!(linkToken && ready)}
      style={{
        fontSize: '1em',
        marginBottom: '1em',
        width: '100%',
      }}
    >
      {text}
    </SecondaryButton>
  ) : (
    <Button
      motif="primary"
      size="small"
      variant="outline"
      id={id}
      data-testid={id}
      onClick={event => {
        event.preventDefault();
        linkToken && open();
      }}
      disabled={!(linkToken && ready)}
      style={{ width: '175px' }}
    >
      {text}
    </Button>
  );
};
